<template>
    <div class="login-view">
        <div class="login-view__card">
            <form class="login-form">
                <input class="login-form__input"
                       type="text"
                       v-model="unum"
                       placeholder="U Nummer"
                />

                <input class="login-form__input"
                       type="password"
                       v-model="pw"
                       placeholder="Passwort"
                />

                <default-button :variations="['full-width']" @click.prevent="login">
                    Login
                </default-button>
            </form>
        </div>

        <div class="login-view__forgot-password"
             @click="forgotPW()"
             title="hahahahah, ok, guet. U Nummer im Login feld eingeben und diesen link klicken."
        >
            Forgot password
        </div>
    </div>
</template>

<script>
import DefaultButton from '../common/default-button';
export default {
    components: { DefaultButton },
    data() {
        return {
            unum: '',
            pw: ''
        }
    },
    props: {
        path: {
            type: String,
            default: '/fotodatenbank'
        }
    },
    methods: {
        login() {
            // make sure the inputs are not empty
            if (this.unum === '') {
                this.$store.dispatch('notifications/notification', {
                    msg: 'enter U nummer',
                    error: true,
                    time: 2000
                });
            } else if (this.pw === '') {
                this.$store.dispatch('notifications/notification', {
                    msg: 'enter password',
                    error: true,
                    time: 2000
                });
            } else {
                this.$store.dispatch('user/login', { unum: this.unum, pw: this.pw, path: this.path });
            }
        },
        forgotPW() {
            if (this.unum === '') {
                this.$store.dispatch('notifications/notification', {
                    msg: 'enter U nummer',
                    error: true,
                    time: 2000
                });
            } else {
                this.$store.dispatch('user/sendResetPWEmail', { unum: this.unum });
            }
        }
    }
}
</script>

<style scoped lang="scss">
    .login-view {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100vh;
    }

    .login-view__card {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;

        @include medium {
            width: 19rem;
            @include default-shadow;
        }

        @include extra-large {
            width: 31rem;
            @include default-shadow;
        }
    }

    .login-form {
        padding: 1rem;
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
    }

    .login-form__input {
        width: 100%;
        font-size: 2rem;
        margin-bottom: 1rem;

        @include extra-large {
            font-size: 3rem;
        }
    }

    .login-form__button {
        width: 50%;
        font-size: 2rem;
    }

    .login-view__forgot-password {
        position: absolute;
        bottom: 1.25rem;
        color: $color-gray;
        cursor: pointer;

        &:active {
            color: $color-green;
        }
    }
</style>
